import {
  Dumbbell,
  Swords,
  Car,
  Home,
  Droplets,
  Leaf,
  HeartPulse,
  Store,
} from "lucide-react";

const NICHES = [
  { label: "MMA Gyms", icon: Dumbbell },
  { label: "BJJ Academies", icon: Swords },
  { label: "Auto Detailers", icon: Car },
  { label: "Roofing Companies", icon: Home },
  { label: "Pressure Washing", icon: Droplets },
  { label: "Landscaping", icon: Leaf },
  { label: "Personal Trainers", icon: HeartPulse },
  { label: "Local Services", icon: Store },
];

export default function Niches() {
  // Duplicated for seamless marquee loop
  const loop = [...NICHES, ...NICHES];

  return (
    <section
      id="niches"
      data-testid="niches-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="text-xs tracking-[0.22em] uppercase text-blue-400 font-medium">
            Built for these niches
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mt-4 leading-[1.1]">
            Websites for businesses that{" "}
            <span className="italic">need more customers</span>.
          </h2>
          <p className="mt-5 text-white/55 max-w-2xl text-sm md:text-base">
            I focus on local service businesses where a clean, trustworthy
            website directly translates into more bookings, calls and
            estimates.
          </p>
        </div>

        {/* Grid (desktop) */}
        <div className="mt-14 hidden md:grid grid-cols-2 lg:grid-cols-4 gap-4">
          {NICHES.map((n) => {
            const Icon = n.icon;
            return (
              <div
                key={n.label}
                data-testid={`niche-card-${n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                className="group card-soft rounded-xl p-5 flex items-center gap-4 transition-all hover:-translate-y-0.5"
              >
                <span className="h-11 w-11 rounded-lg flex items-center justify-center border border-white/10 bg-white/[0.03] text-white/80 group-hover:border-blue-500/40 group-hover:bg-blue-500/10 group-hover:text-blue-300 transition-colors">
                  <Icon size={20} />
                </span>
                <div>
                  <div className="text-white font-medium text-sm md:text-base">
                    {n.label}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.18em] text-white/35 mt-0.5">
                    Niche
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Marquee (mobile) */}
        <div className="mt-12 md:hidden relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          <div className="flex gap-4 marquee-track w-max">
            {loop.map((n, i) => {
              const Icon = n.icon;
              return (
                <div
                  key={`${n.label}-${i}`}
                  className="shrink-0 card-soft rounded-xl px-5 py-4 flex items-center gap-3"
                >
                  <Icon size={18} className="text-blue-300" />
                  <span className="text-sm text-white whitespace-nowrap">
                    {n.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
